import { gql } from "@apollo/client";

const SCHEDULES_QUERY = gql`
  query GetSchedules(
    $serviceOrCategoryId: Int!
    $pageType: String!
    $countryCode: String!
    $citySlug: String!
  ) {
    scheduleServiceCountry(
      mapping_id: $serviceOrCategoryId
      country_short_name: $countryCode
      page_type: $pageType
      city_slug: $citySlug
    )
  }
`;

export default SCHEDULES_QUERY;
